import {
  IImageFields,
  SpecificLocaleFields,
} from "~/@types/generated/contentful";
import { getTwicPicsURL } from "../utils/getTwicPicsURL";

type ImgProps = {
  image: SpecificLocaleFields<IImageFields>;
  className?: string;
  width?: number;
};

export default function ContentfulImg({
  image,
  className = "",
  width,
}: ImgProps) {
  return (
    <img
      src={getTwicPicsURL(image, { width })}
      alt={image.alt ?? "image"}
      className={className}
      onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) =>
        (e.currentTarget.src =
          "https://tbi-assets.s3.eu-west-2.amazonaws.com/all-images/placeholder.png")
      }
    />
  );
}
